import { forwardRef } from 'react';
import {Card, Col, Row} from 'react-bootstrap';
import ArrowButton from '../../../../common/button-arrow';

// forwardRef so react-sortable-hoc (vendored, React-19) can capture this row's
// DOM node via a ref instead of the removed findDOMNode.
const NavigationLinkItem = forwardRef(({item, ...props}, ref) => (
  <Card ref={ref} className="product-item">
    <Card.Body>
      <Row>
        <Col md={8} style={{userSelect: 'none'}}>
          {item.attributes.name}
        </Col>
        <Col md={4}>
          <ArrowButton
            arrow={false}
            className="float-end"
            onClick={() => props.onDelete(item.id)}
            permissions={{
              action: 'remove',
              subjectClass: 'NavigationLink'
            }}
            submit={false}
          >
            Delete
          </ArrowButton>
          <ArrowButton
            arrow={false}
            className="float-end"
            color="grey"
            onClick={() => props.onEdit(item.id)}
            permissions={{
              action: 'edit',
              subjectClass: 'NavigationLink'
            }}
            submit={false}
          >
            Edit
          </ArrowButton>
        </Col>
      </Row>
    </Card.Body>
  </Card>
));

NavigationLinkItem.displayName = 'NavigationLinkItem';

export default NavigationLinkItem;
